import { useState } from "react";
import formatMoney from "../../../utils/formatMoney";
import AssetsPanel from "./AssetsPanel";

export default function ClassWidget({ item, year, center, refetch }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const [assets, setAssets] = useState<any>([]);
  const [title, setTitle] = useState<any>([]);
  const handleSelectClass = () => {
    setAssets(item?.list);
    setTitle(item?._id);
    setVisible(true);
  };

  return (
    <div className="col-span-12 sm:col-span-2 border bg-white hover:cursor-pointer hover:bg-gray-50">
      <div className="flex  p-2" onClick={() => handleSelectClass()}>
        <div className="flex flex-col w-full">
          <div className="uppercase text-lg text-gray-600">
            {item?._id === null ? "Miscellaneous" : item?._id}
          </div>
          <div className="flex justify-between items-center">
            <div className="">{formatMoney(item?.price)}</div>
            <div className="">{item?.count}</div>
          </div>
        </div>
        {/* <div className="flex justify-center items-center w-10 h-10 mr-4 rounded-md  bg-red-100">
          <span className="text-2xl">{item?.count}</span>
        </div>
        <div className="border-l-2 h-full pl-4">{item?._id}</div> */}
      </div>
      <AssetsPanel
        isVisible={isVisible}
        setVisible={setVisible}
        assets={assets}
        title={title}
        year={year}
        center={center}
        refetch={refetch}
      />
    </div>
  );
}
